export const defaultAuthValues = {
  application: 'Pik iOS',
  devicetoken: '-',
  platform: 1,
} as const;

export const storageKeys = {
  token: 'access_token',
};
